import React from 'react';
import { useForm } from 'services/hooks';
import { FormContext } from './hooks';

const GeckoForm = ({
  initialValues,
  onSubmit,
  validate,
  requiredFields: required,
  children,
  ...props
}) => {
  const formState = useForm({
    initialValues,
    onSubmit,
    validate,
    requiredFields: required,
  });
  const {
    values,
    handleChange,
    errors,
    requiredErrors,
    touched,
    handleSubmit,
    requiredFields,
    hasTriedToSubmit,
  } = formState;
  return (
    <FormContext.Provider
      value={{
        values,
        handleChange,
        errors,
        requiredErrors,
        touched,
        requiredFields,
        hasTriedToSubmit,
      }}
    >
      <form className={'GeckoForm'} onSubmit={handleSubmit} {...props}>
        {children(formState)}
      </form>
    </FormContext.Provider>
  );
};

export default GeckoForm;
